/* eslint-disable */

let menu = []
const role = JSON.parse(localStorage.getItem('DuttonAuthUser')).role

// switch case with role
switch (role) {
  case 'admin':
    menu = [
      {
        header: 'Menú',
      },
      {
        title: 'Inicio',
        route: 'home',
        icon: 'HomeIcon',
      },
      {
        title: 'Asistente',
        route: 'chat-assistant',
        icon: 'MessageSquareIcon',
      },
      {
        title: 'Catálogos',
        icon: 'FolderIcon',
        children: [
          {
            title: 'Categorías',
            route: 'catalogs-categories',
          },
          {
            title: 'Colores',
            route: 'catalogs-colors',
          },
          {
            title: 'Tallas',
            route: 'catalogs-sizes',
          },
          {
            title: 'Productos',
            route: 'catalogs-products',
          },
          {
            title: 'Inventario',
            route: 'catalogs-inventory',
          },
          {
            title: 'Listas de Precios',
            route: 'catalogs-price-lists',
          },
        ],
      },
      {
        title: 'Contactos',
        icon: 'UsersIcon',
        children: [
          {
            title: 'Clientes',
            route: 'contacts-customers',
          },
          {
            title: 'Rutas',
            route: 'contacts-customer-routes',
          },
        ],
      },
      {
        title: 'Ventas',
        icon: 'BoxIcon',
        children: [
          {
            title: 'Cotizaciones',
            route: 'sales-customer-quotes',
          },
          {
            title: 'Pedidos',
            route: 'sales-customer-orders',
          },
          {
            title: 'Venta Caída',
            route: 'sales-lost-sales',
          },
        ],
      },
      {
        title: 'Sistema',
        icon: 'SettingsIcon',
        children: [
          {
            title: 'Usuarios',
            route: 'users',
          },
          {
            title: 'Estadísticas IA',
            route: 'system-chat-stats',
            icon: 'BarChart2Icon',
          },
          {
            title: 'Prompt IA',
            route: 'system-chat-prompt',
            icon: 'FileTextIcon',
          },
          /* {
            title: 'Actualizaciones',
            route: 'updates',
          }, */
        ],
      },
    ]
  break
  case'vendor':
    menu = [
      {
        header: 'Menú',
      },
      {
        title: 'Inicio',
        route: 'home',
        icon: 'HomeIcon',
      },
      {
        title: 'Asistente',
        route: 'chat-assistant',
        icon: 'MessageSquareIcon',
      },
      {
        title: 'Catálogos',
        icon: 'FolderIcon',
        children: [
          {
            title: 'Categorías',
            route: 'catalogs-categories',
          },
          {
            title: 'Colores',
            route: 'catalogs-colors',
          },
          {
            title: 'Tallas',
            route: 'catalogs-sizes',
          },
          {
            title: 'Productos',
            route: 'catalogs-products',
          },
          {
            title: 'Inventario',
            route: 'catalogs-inventory',
          },
        ],
      },
      {
        title: 'Contactos',
        icon: 'UsersIcon',
        children: [
          {
            title: 'Clientes',
            route: 'contacts-customers',
          },
        ],
      },
      {
        title: 'Ventas',
        icon: 'BoxIcon',
        children: [
          {
            title: 'Cotizaciones',
            route: 'sales-customer-quotes',
          },
          {
            title: 'Pedidos',
            route: 'sales-customer-orders',
          },
          {
            title: 'Venta Caída',
            route: 'sales-lost-sales',
          },
        ],
      },
    ]
  break
  default:
    menu = []
    break
}
        
export default menu
/* eslint-disable */
